import { z } from "zod";

export const brandSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  organizationId: z.string().uuid().nullable(),
});
export type Brand = z.infer<typeof brandSchema>;
